<template>
    <base-card-list-entry class="relative">
        <div class="flex items-center">
            <div class="max-w-250 truncate">
                <span class="text-gray-700 text-base font-bold max-w-250">
                    <a :href="detailRoute" class="boxLink">{{ interruption.name }}</a>
                </span>
                <host-list class="text-xs font-bold text-gray-600 mt-2" style="white-space: normal;" :hosts="hosts" v-if="hosts.length"></host-list>
                <p class="text-gray-700 text-sm" v-else>No Host</p>
            </div>
            <div class="ml-auto pl-4">
                <div class="px-2 py-1 bg-orange-200 text-xs text-orange-800 rounded-full font-bold leading-tight flex items-center" v-if="minor">
                    <div class="w-1 h-1 rounded-full bg-orange-400"></div>
                    <span class="ml-1">Minor</span>
                </div>
                <div class="px-2 py-1 bg-red-200 text-xs text-red-800 rounded-full font-bold leading-tight flex items-center" v-else-if="major">
                    <div class="w-1 h-1 rounded-full bg-red-400"></div>
                    <span class="ml-1">Major</span>
                </div>
            </div>
        </div>
        <div class="text-gray-700 text-sm mt-1" v-if="interruption.comment">
            <p>{{ interruption.comment }}</p>
        </div>
        <div class="text-xs font-bold text-gray-600 mt-2 flex lg:justify-between lg:items-center flex-col lg:flex-row">
            <span class="flex items-center">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>
                {{ interruption.started_at }}
            </span>
            <div v-if="interruption.estimated_to_end_at">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="transform rotate-90 my-2 lg:my-0 lg:mx-2 lg:rotate-0"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </div>
            <span class="flex items-center" v-if="interruption.estimated_to_end_at">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                <span>{{ interruption.estimated_to_end_at }}</span>
            </span>
        </div>
    </base-card-list-entry>
</template>

<script>
    export default {
        props: {
            interruption: {
                required: true,
                type: Object,
            },
            hosts: {
                required: true,
                type: Array,
            },
        },
        computed: {
            startTime() {
                return new Date(this.interruption.started_at_timestamp * 1000);
            },
            estimatedEndTime() {
                return new Date(this.interruption.estimated_to_end_at_timestamp * 1000);
            },
            estimatedTimeInHours() {
                return Math.abs(this.estimatedEndTime - this.startTime) / 36e5;
            },
            minor() {
                return this.estimatedTimeInHours < 2;
            },
            major() {
                return this.estimatedTimeInHours >= 2;
            },
            detailRoute() {
                if (this.interruption.is_summary === true) {
                    return route('interruptionSummary', {
                        interruptionID: this.interruption.id
                    });
                } else {
                    return route('interruption', {
                        interruptionID: this.interruption.id
                    });
                }
            },
        },
    }
</script>
